if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        //this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cart = document.querySelector('mini-cart');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (this.classList.contains('sticky-cart__form')) {
          this.submitButton.addEventListener('click', this.onStickyCartClick.bind(this), { capture: true });
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onStickyCartClick(evt) {
        // The variant input named id shadows HTMLFormElement.id.
        const primaryForm = document.getElementById((this.form.getAttribute('id') || '').replace(/--alt$/, ''));
        const primarySubmitButton = primaryForm?.querySelector('[type="submit"]');
        if (!primarySubmitButton || primarySubmitButton === this.submitButton) return;

        evt.preventDefault();
        evt.stopImmediatePropagation();
        if (this.submitButton.getAttribute('aria-disabled') === 'true' || primarySubmitButton.disabled || primarySubmitButton.getAttribute('aria-disabled') === 'true') return;

        const stickyQuantity = this.form.querySelector('[name="quantity"]');
        if (stickyQuantity) {
          let primaryQuantity = primaryForm.querySelector('[name="quantity"]');
          if (!primaryQuantity) {
            primaryQuantity = document.createElement('input');
            primaryQuantity.type = 'hidden';
            primaryQuantity.name = 'quantity';
            primaryQuantity.dataset.stickyCartQuantity = '';
            primaryForm.appendChild(primaryQuantity);
          }
          primaryQuantity.value = stickyQuantity.value;
        }

        const primaryProductForm = primaryForm.closest('product-form');
        primaryProductForm.stickySubmissionSource = this;
        try {
          primaryForm.requestSubmit(primarySubmitButton);
        } finally {
          if (primaryProductForm.stickySubmissionSource === this) primaryProductForm.stickySubmissionSource = null;
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const stickySource = this.stickySubmissionSource;
        this.stickySubmissionSource = null;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.closest('product-info')?.querySelector('product-form.sticky-cart__form')?.handleErrorMessage();
        if (!this.blockSubmitIfRequiredFieldsEmpty(evt, stickySource)) return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (stickySource) {
          stickySource.submitButton.setAttribute('aria-disabled', true);
          stickySource.submitButton.classList.add('loading');
        }
        //this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 20000);
        config.signal = controller.signal;

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              (stickySource || this).handleErrorMessage(response.description, Boolean(stickySource));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = theme.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cart: response,
              });
            this.error = false;
            if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            (stickySource || this).handleErrorMessage(
              "We couldn't confirm this item was added. Check your cart before trying again.",
              true,
              true
            );
          })
          .finally(() => {
            window.clearTimeout(timeout);
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            stickySource?.submitButton.classList.remove('loading');
            stickySource?.submitButton.removeAttribute('aria-disabled');
            //this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      blockSubmitIfRequiredFieldsEmpty(event, stickySource) {
        if (!(this.form instanceof HTMLFormElement)) {
          throw new Error("Expected a form element.");
        }

        const formId = this.form.getAttribute('id');
        const requiredFields = document.querySelectorAll('[required]');
        let allFilled = true;
        for (const field of requiredFields) {
          const belongsToForm = (field.getAttribute('form') === formId || field.closest('form')?.id === formId);
          if (!belongsToForm) continue;
          
          let isValid = true;
          switch (field.type) {
            case 'checkbox':
            case 'radio':
              const group = document.querySelectorAll(`input[name="${field.name}"][type="${field.type}"]`);
              const isChecked = Array.from(group).some(input => input.checked);
              isValid = isChecked;
              break;
            case 'select-one':
              isValid = field.value !== '';
              break;
            case 'textarea':
            case 'text':
            case 'email':
            case 'number':
            case 'url':
            default:
              isValid = field.value.trim() !== '';
              break;
          }
          if (!isValid) {
            allFilled = false;
            field.classList.add('invalid');
          } else {
            field.classList.remove('invalid');
          }
        }
    
        if (!allFilled) {
          event.preventDefault();
          (stickySource || this).handleErrorMessage(theme.accessibilityStrings.fillInAllLineItemPropertyRequiredFields, Boolean(stickySource));
          return false;
        }
        return true;
      }
      
      handleErrorMessage(errorMessage = false, force = false, showCartLink = false) {
        if (this.hideErrors && !force && errorMessage) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper && force) {
          this.errorMessageWrapper = document.createElement('div');
          this.errorMessageWrapper.className = 'product-form__error-message-wrapper';
          this.errorMessageWrapper.setAttribute('role', 'alert');
          this.errorMessage = document.createElement('span');
          this.errorMessage.className = 'product-form__error-message';
          this.errorMessageWrapper.appendChild(this.errorMessage);
          this.prepend(this.errorMessageWrapper);
        }
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        if (errorMessage) {
          const contents = [document.createTextNode(errorMessage)];
          if (showCartLink) {
            const cartLink = document.createElement('a');
            cartLink.href = theme.routes.cart_url;
            cartLink.textContent = 'View cart';
            cartLink.className = 'link';
            contents.push(document.createTextNode(' '), cartLink);
          }
          this.errorMessage.replaceChildren(...contents);
        } else {
          this.errorMessage.replaceChildren();
        }
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = theme.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
